import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Shield, Loader2 } from 'lucide-react';

const UpgradeToMainAdmin = () => {
  const [upgrading, setUpgrading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleUpgrade = async () => {
    setUpgrading(true);
    try {
      const response = await axios.get(`${API}/admin/upgrade-to-main-admin?secret=MAIN2025`);
      
      toast.success(response.data.message);
      setSuccess(true);
      
      setTimeout(() => {
        // Logout and redirect to login
        localStorage.removeItem('token');
        window.location.href = '/login';
      }, 3000);
      
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Kon nie opgradeer nie';
      toast.error(errorMsg);
      console.error('Upgrade error:', error);
    } finally {
      setUpgrading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-50 p-8">
      <div className="max-w-2xl mx-auto">
        <Card className="border-blue-200">
          <CardHeader>
            <CardTitle className="text-2xl flex items-center gap-2 text-blue-600">
              <Shield className="h-6 w-6" />
              Opgradeer na Hoof Admin
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            {!success ? (
              <>
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <p className="text-sm text-gray-700 mb-3">
                    Hierdie bladsy sal jou admin rekening opgradeer na <strong>hoof admin</strong> status.
                  </p>
                  <p className="text-sm text-gray-700 mb-3">
                    As hoof admin sal jy toegang hê tot:
                  </p>
                  <ul className="list-disc ml-6 text-sm text-gray-700 space-y-1">
                    <li>Boekdata herstel funksie</li>
                    <li>Gebruiker bestuur (skep en verwyder alle gebruikers)</li>
                    <li>Stelsel instellings</li>
                    <li>Alle admin funksies</li>
                  </ul>
                </div>

                <Button
                  onClick={handleUpgrade}
                  disabled={upgrading}
                  className="w-full bg-blue-600 hover:bg-blue-700"
                  size="lg"
                >
                  {upgrading ? (
                    <>
                      <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                      Besig om op te gradeer...
                    </>
                  ) : (
                    <>
                      <Shield className="mr-2 h-5 w-5" />
                      Opgradeer na Hoof Admin
                    </>
                  )}
                </Button>
              </>
            ) : (
              <div className="bg-green-50 p-6 rounded-lg border border-green-200 text-center">
                <p className="text-lg font-semibold text-green-700 mb-2">
                  ✅ Suksesvol opgegradeer!
                </p>
                <p className="text-sm text-gray-700">
                  Jy word nou uitgeteken en terug gestuur na die aanmeld bladsy...
                </p>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default UpgradeToMainAdmin;
